var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"placeholder":"请输入账号"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }